export default {
  auth: {
    username: 'username',
    password: 'passowrd',
    login: 'Sign in',
    logout: 'Log out'
  },
  general: {
    detail: 'Detail',
    save: 'Save',
    cancel: 'Cancel',
    assign: 'Assign',
    close: 'Close',
    submit: 'Submit'
  },
  route: {
    order: 'feedback',
    schedule: 'All',
    history: 'New'
  },
  schedule: {
    district: 'District',
    coach: 'Coach',
    schedule: 'Schedule',
    vehicle: 'Vehicle',
    start_address: 'Start Address',
    end_address: 'End Address',
    notes: 'Notes'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js